// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ob_v","delete":"styles_delete__1nKM9","update":"styles_update__35ycg","add":"styles_add__3fRON"};